// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"528":"00177c68315e694956f0","803":"ca3a2d62c6e61ea24fab"}[chunkId] + ".js";
};